'use client';

import type React from 'react';

import { cn } from '@/lib/utils';

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export function PromptInput({ className, ...props }: DivProps) {
  return <div className={cn('flex flex-col rounded-md bg-muted', className)} {...props} />;
}

export function PromptInputBody({ className, ...props }: DivProps) {
  return <div className={cn('px-2 pb-1', className)} {...props} />;
}

export function PromptInputFooter({ className, ...props }: DivProps) {
  return <div className={cn('flex items-end gap-2 px-3 pb-3', className)} {...props} />;
}

export function PromptInputTools({ className, ...props }: DivProps) {
  return (
    <div
      className={cn('flex min-w-0 shrink items-center gap-1 overflow-hidden', className)}
      {...props}
    />
  );
}
